var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "header-row" }, [
    !_vm.isSubscribed
      ? _c(
          "div",
          { staticClass: "header-left" },
          [
            _c(
              "ib-button",
              {
                attrs: {
                  variant: "black",
                  outline: "",
                  size: "sm",
                  "font-family": "medium",
                  "submit-button": "",
                },
                on: { click: _vm.onClickBackBtn },
              },
              [_vm._v(" " + _vm._s(_vm.$t("back")) + " ")]
            ),
          ],
          1
        )
      : _vm._e(),
    _c(
      "div",
      { staticClass: "header-center" },
      [
        _vm.subscriptionIsFreeTrialExpired
          ? _c("subscription-alert", {
              attrs: {
                "rounded-mode": "always",
                text: `${_vm.$t("pages.billing.yourFreeTrialHasExpired")}`,
              },
            })
          : _vm._e(),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }